import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import LoadingScreen from 'components/Shared/LoadingScreen';
import QuestionComments from 'components/Course/Shared/QuestionComments';
import QuestionPreview from 'components/Course/Shared/QuestionPreview';
import Button from 'uikit/Button';
import Tooltip from 'uikit/Tooltip';

import Actions from './Actions';
import AggregatedAnswers from './AggregatedAnswers';
import ChapterEdit from './ChapterEdit';
import ChapterMove from './ChapterMove';
import Empty from './Empty';
import FileImport from './FileImport';
import Finder from './Finder';
import Multi from './Multi';
import QuestionEdit from '../../Shared/QuestionEdit';
import QuestionImport from './QuestionImport';
import QuestionMove from './QuestionMove';
import QuestionsMove from './QuestionsMove';
import StudentErrors from './StudentErrors';
import styles from './Editor.module.scss';

const cx = classNames.bind(styles);

const Editor = ({
  className,
  course,
  handleQuestionCreateFromIA,
  isEmpty,
  isLoading,
  nQuestions,
  t,
  wantsAI,
}) =>
  isLoading ? (
    <LoadingScreen />
  ) : (
    <>
      <div className={cx('container', className)}>
        <div className={cx('header')} id="editor-header">
          <h3 className={cx('title')}>
            {t('Course/Teacher/Editor/title')}
            <span className={cx('count')}>{nQuestions}</span>
          </h3>
          <Multi className={cx('action')} course={course} />
          {wantsAI && (
            <Tooltip tooltip={t('Course/Teacher/Editor/from-ia-tooltip')}>
              <Button
                icon="wand-sparkles"
                intent="ia-light"
                onClick={handleQuestionCreateFromIA}
              >
                {t('Course/Teacher/Editor/create-from-ia')}
              </Button>
            </Tooltip>
          )}
          <Actions course={course} />
        </div>
        {course.isExam && course.examStartTime === course.examStopTime && (
          <Link className={cx('warning')} to={`/course/${course.id}/settings`}>
            {t('Course/Teacher/Editor/warning-settings')}
          </Link>
        )}
        {isEmpty ? (
          <Empty />
        ) : (
          <Finder className={cx('finder')} course={course} />
        )}
      </div>
      <AggregatedAnswers course={course} />
      <ChapterEdit course={course} />
      <ChapterMove course={course} />
      <FileImport course={course} />
      <QuestionComments course={course} />
      <QuestionEdit course={course} />
      <QuestionImport course={course} />
      <QuestionMove course={course} />
      <QuestionsMove course={course} />
      <QuestionPreview course={course} />
      <StudentErrors course={course} />
    </>
  );

Editor.propTypes = {
  className: PropTypes.string,
  course: PropTypes.object,
  handleQuestionCreateFromIA: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  nQuestions: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
  wantsAI: PropTypes.bool.isRequired,
};

Editor.defaultProps = {
  className: undefined,
  course: undefined,
};

export default Editor;
